<template lang="html">
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color':currentIntegration.color.main}">
        <div slot="title">
            <h2>Add new</h2>
        </div>

        <div slot="body">
            <!-- Top area -->
            <top-area :integration="currentIntegration" >
               <div class="bg-blue-pale p-2 mt-3">
                    Please note: This integration is exclusively available for OTAs that use the OCTO standard.
                </div>
            </top-area>

            <div class="px-5 pb-4">
                <div class="create-octo-integration__fields--fixed-height row py-3">
                    <div class="col-sm-6">
                        <label class="full">
                            Name<span class="brand ml-1">*</span>
                            <input type="text" v-model="octo.name">
                        </label>
    
                        <div v-if="$v.octo.name.$invalid" class="error">
                            <span v-if="!$v.octo.name.required">Name is required.</span>
                            <span v-if="!$v.octo.name.minLength">Name must have at least 5 characters.</span>
                                <span v-if="!$v.octo.name.validCharacters">
                                Invalid characters. Please use only letters and numbers.
                            </span>
                        </div>
                    </div>
    
                    <div class="col-sm-6">
                        <label class="full">
                            Email<span class="brand ml-1">*</span>
                            <input type="text" v-model="octo.email">
                        </label>
                        
                        <div v-if="$v.octo.email.$invalid" class="error">
                            <span v-if="!$v.octo.email.required">Email is required.</span>
                            <span v-if="!$v.octo.email.isEmailValid">Must be a valid email</span>
                        </div>
                    </div>
                </div>
                
                <bottom-area
                    :disableConnectBtn="$v.octo.$invalid"
                    :showConnectBtn="true"
                    :loadingConnectBtn="isOctoConnecting"
                    @connectIntegration="connect()"
                    @close="closeModal()"
                />
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, minLength } from "vuelidate/lib/validators"

import Modal from '@/tools/modal/Modal'
import loader from '@/tools/loaders/loader1'
import topArea from '../../components/integrations/integratePopup/popupParts/topArea.vue'
import bottomArea from '../../components/integrations/integratePopup/popupParts/bottomArea'

export default {
    data() {
        return {
            octo: {
                name: '',
                email: '',
            }
        }
    },
    validations: {
        octo: {
            name: {
                required,
                minLength: minLength(5),
                validCharacters: function (val) {
                    return this.validCharacters(val);
                }
            },
            email: {
                required,
                isEmailValid: function (val) {
                    return this.emailValidation(val);
                },
            },
        },
    },
    computed: {
        ...mapGetters([
            'getSingleIntegration',
            'getIsOctoConnecting'
        ]),
        isOctoConnecting() {
            return this.getIsOctoConnecting;
        },
        currentIntegration() {
            return this.getSingleIntegration(205);
        },
    },
    methods: {
        ...mapActions([
            'downloadPaymentIntegrationDetails',
            'requestIntegrationDeactivationViaEmail',
            'closeModal',
            'createOctoIntegration',
            'downloadSupplierIntegrations',
            'downloadAgents'
        ]),
        validCharacters(val) {
            const allowedCharacters = /^[a-zA-Z0-9\s]*$/;
            
            return allowedCharacters.test(val);
        },
        emailValidation(val) {
            if (!val) {
                return false;
            }

            let separator = null;
            
            if (val.includes(",")) {
                separator = ",";
            } else if (val.includes(";")) {
                separator = ";";
            }

            let emailArray = separator ? val.split(separator) : [val];

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

            return emailArray.every(email => emailRegex.test(email.trim()));
        },
        connect() {
            this.createOctoIntegration(this.octo).then(wasOctoCreated => {
                if(wasOctoCreated){
                    this.downloadAgents();
                    this.downloadSupplierIntegrations();
                    this.closeModal();
                }
            });
        },
        close() {
            this.closeModal();
        }
    },
    components: {
        topArea,
        bottomArea,
        Modal,
        loader,
    }
}
</script>

<style lang="scss" scoped>
    .create-octo-integration__fields--fixed-height {
        min-height: 110px;
    }
</style>



// WEBPACK FOOTER //
// createOctoIntegration.vue?53c8ed52